import { Component, createRef } from 'react';

class AdSenseAd728 extends Component {
  constructor(props) {
    super(props);
    this.adRef = createRef();
  }

  componentDidMount() {
    try {
      if (window.adsbygoogle && this.adRef.current) {
        window.adsbygoogle.push({});
      }
    } catch (e) {
      console.error('AdSense error:', e);
    }
  }

  render() {
    return (
      <ins
        className="adsbygoogle"
        style={{ display: 'block' }}
        data-ad-client="ca-pub-0193275510308560"
        data-ad-slot="5076421992"
        data-ad-format="auto"
        data-full-width-responsive="true"
        ref={this.adRef}
      />
    );
  }
}

export default AdSenseAd728;
